import React, { useEffect, useState } from "react";
import { agentApi } from "../../services/agentApi";

const DAYS = [
  { key: "mon", label: "Segunda" }, { key: "tue", label: "Terça" },
  { key: "wed", label: "Quarta" }, { key: "thu", label: "Quinta" },
  { key: "fri", label: "Sexta" }, { key: "sat", label: "Sábado" },
  { key: "sun", label: "Domingo" },
];

export default function WeeklyRulesModal({ traderId, onClose, onSaved }) {
  const [rules, setRules] = useState({
    timezone: "America/Sao_Paulo",
    slotMinutes: 30,
    windows: { mon: [], tue: [], wed: [], thu: [], fri: [], sat: [], sun: [] },
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!traderId) return;
    setLoading(true);
    agentApi.traders.getWeeklyRules(traderId)
      .then((r) => {
        if (r.weeklyRules) setRules(r.weeklyRules);
      })
      .finally(() => setLoading(false));
  }, [traderId]);

  function toggle(day) {
    setRules((s) => {
      const w = { ...s.windows };
      if ((w[day] ?? []).length > 0) w[day] = [];
      else w[day] = [["10:00", "12:00"], ["14:00", "17:00"]];
      return { ...s, windows: w };
    });
  }

  function update(day, idx, pos, val) {
    setRules((s) => {
      const w = { ...s.windows };
      const ranges = [...(w[day] ?? [])];
      const r = [...ranges[idx]];
      r[pos] = val;
      ranges[idx] = r;
      w[day] = ranges;
      return { ...s, windows: w };
    });
  }

  function addRange(day) {
    setRules((s) => {
      const w = { ...s.windows };
      w[day] = [...(w[day] ?? []), ["09:00", "18:00"]];
      return { ...s, windows: w };
    });
  }

  function removeRange(day, idx) {
    setRules((s) => {
      const w = { ...s.windows };
      w[day] = (w[day] ?? []).filter((_, i) => i !== idx);
      return { ...s, windows: w };
    });
  }

  async function save() {
    setSaving(true);
    try {
      await agentApi.traders.patchWeeklyRules(traderId, rules);
      onSaved && onSaved();
      onClose && onClose();
    } catch (err) {
      alert(`Erro: ${err.message}`);
    } finally {
      setSaving(false);
    }
  }

  if (!traderId) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">Regras semanais do trader</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-xl">×</button>
        </div>

        {loading ? (
          <div className="p-6 text-gray-500">Carregando...</div>
        ) : (
          <div className="p-4 space-y-3">
            <div className="text-sm text-gray-600">
              Configure os dias e janelas em que você atende reuniões. Slots de {rules.slotMinutes ?? 30} minutos.
            </div>
            {DAYS.map(({ key, label }) => {
              const ranges = rules.windows?.[key] ?? [];
              const active = ranges.length > 0;
              return (
                <div key={key} className="flex items-start gap-3 p-3 border border-gray-200 rounded bg-gray-50">
                  <label className="flex items-center gap-2 w-28 text-gray-900 font-medium">
                    <input type="checkbox" checked={active} onChange={() => toggle(key)} />
                    {label}
                  </label>
                  <div className="flex-1 space-y-1">
                    {active && ranges.map((r, i) => (
                      <div key={i} className="flex items-center gap-2">
                        <input type="time" value={r[0]} onChange={(e) => update(key, i, 0, e.target.value)}
                               className="px-2 py-1 bg-white border border-gray-300 text-gray-900 rounded text-sm" />
                        <span className="text-gray-400">—</span>
                        <input type="time" value={r[1]} onChange={(e) => update(key, i, 1, e.target.value)}
                               className="px-2 py-1 bg-white border border-gray-300 text-gray-900 rounded text-sm" />
                        <button onClick={() => removeRange(key, i)} className="text-red-500 text-sm px-1">×</button>
                      </div>
                    ))}
                    {active && (
                      <button onClick={() => addRange(key)} className="text-xs text-blue-600 hover:text-blue-700">
                        + Adicionar janela
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
            <div className="flex justify-end gap-2 pt-3 border-t border-gray-200">
              <button onClick={onClose} className="px-4 py-2 border border-gray-300 text-gray-700 rounded">
                Cancelar
              </button>
              <button onClick={save} disabled={saving} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 text-white rounded">
                {saving ? "Salvando..." : "Salvar regras"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
